import { Card } from "@/components/ui/Card";
import SerciceTableView from "./component/table";
import useDocumentTitle from "@/hooks/UseDocumentTitle";

export default function ServiceManagement() {
  useDocumentTitle("Service Management");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <SerciceTableView />
      </Card>
    </div>
  );
}
